import { css } from '@emotion/css';

export const feedbackModalStyles = css`
	width: 95vw !important;
	max-width: 95vw !important;

	.modal-body {
		overflow-y: auto;
	}
	.feedback-table {
		width: auto;
		margin: 0 auto;
	}
	.feedback-th {
		text-align: left;
	}
	.feedback-label-cell {
		text-align: left;
		white-space: nowrap;
	}
	.feedback-label-flex {
		display: flex;
		align-items: center;
		gap: 8px;
	}
	.info-icon {
		cursor: pointer;
		font-size: 1.25em;
		line-height: 1;
		display: inline-block;
	}
	.correct-badge {
		margin-left: 8px;
	}
	.rejoinder {
		margin-top: 2px;
		margin-left: 1.5rem;
		color: #6c757d;
		font-style: italic;
	}
`;
